import styled from 'styled-components'
import Link from 'next/link'
import PropTypes from 'prop-types'
import { Button } from 'components/common/button'

export const LocalCTAStyled = styled.div`
  display: flex;
  margin: 3rem 0;
  justify-content: center;
  a {
    color: var(--white);
    text-decoration: none;
    flex-grow: 1;
    display: flex;
    justify-content: center;
  }
  @media(min-width: 768px) {
    a {
      max-width: 300px;
      text-align: center;
    }
  }
`

function CTA({ cta, cta_link }) {
  return (
    <LocalCTAStyled id="blog-cta">
      {cta_link.slice(0, 1) === '/'
        ? (
          <Link href={cta_link}>
            <Button fontWeight="500" fullWidth>
              {cta}
            </Button>
          </Link>
        ) : (
          <Button fontWeight="500" fullWidth as="a" href={cta_link} target="_blank" rel="noopener noreferrer">
            {cta}
          </Button>
        )}
    </LocalCTAStyled>
  )
}

CTA.propTypes = {
  cta: PropTypes.string.isRequired,
  cta_link: PropTypes.string.isRequired,
}

export default CTA
